import React, { useState, useEffect, useMemo, useCallback } from "react";

import isEmpty from "is-empty";

import { useSelector } from "react-redux";

import { useParams, useLocation, useHistory } from "react-router-dom";
import { getLicenseOppTeams } from "../../services/team.services";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay.js";
import DeleteOverlay from "../../UserComponents/overlays/DeleteOverlay.js";
import OppTeamsList from "../../UserComponents/modals/OppTeamsModal.js";
import DatePick from "../../UserComponents/modals/DatePicker.js";
import HomeTeamModal from "../../UserComponents/modals/HomeTeamModal.js";
import TimeInputModal from "./component/TimeInputModal";


import {
  editScheduledGame,
  getOneScheduledGame,
  deleteSchedule,
} from "../../services/game.services";
import { formatMinutesToTimeString } from "../../utils/helper.js";
import {
  GameResultEnum,
  GameStatusForSchedule,
} from "../../../constants/enum.js";
import GameStatusModal from "./component/gameStatusModal";
import ForfeitByModal from "./component/forefeitByModal";

import Checkbox from "@mui/material/Checkbox";

const initialState = {
  userId: null,
  teamA: { teamId: "", teamName: "" },
  teamB: { teamId: "", teamName: "" },
  date: null, // MM-DD-YYYY
  time: null, // 23:30
  homeTeam: null,
  awayTeam: null,
  conference: null,
  gameStatus: "scheduled",
  gameResult: "None",
};

const EditScheduledGame = (props) => {
  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);

  const { gameId } = useParams();
  const location = useLocation();
  const history = useHistory();

  // const gameId = props.route.params.gameId;
  // console.log("gameId from useParams:", gameId);
  const handleGetAllSchedules =
    location.state?.handleGetAllSchedules || (() => {});

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [getScheduleLoading, setGetScheduleLoading] = useState(false);
  const [selectedOppTeam, setSelectedOppTeam] = useState(null);
  const [oppTeamData, setOppTeamData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [datepickerIsvisible, setDatepickerIsvisible] = useState(false);
  const [homeTeamVisible, setHomeTeamVisible] = useState(false);
  const [manualTimeModalVisible, setManualTimeModalVisible] = useState(false);
  const [savedManualTime, setSavedManualTime] = useState(null);

  const [updateTeamLoader, setUpdateTeamLoader] = useState(false);
  const [opptTeamVisible, setOppTeamVisible] = useState(false);
  const [error, setError] = useState(null);
  const [successVisible, setSuccessVisible] = useState(false);

  const [delIsVisible, setDelIsVisible] = useState(false);
  const [delSuccessVisible, setDelSuccessVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [forfeitBy, setForfeitBy] = useState(null);
  const [gameStatusVisible, setGameStatusVisible] = useState(false);
  const [forfeitByVisible, setForfeitByVisible] = useState(false);
  const [gameStatusSelected, setGameStatusSelected] = useState(false);

  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    setTimeout(() => {
      history.push("/gamelog");
      setSuccessVisible(false);
      handleGetAllSchedules();
    }, 2500);
  };
  const toggleDatePicker = () => {
    setDatepickerIsvisible(!datepickerIsvisible);
  };
  const toggleDelSuccessModal = () => {
    setDelIsVisible(false);
    setDelSuccessVisible(!delSuccessVisible);
    setTimeout(() => {
      history.push("/gamelog");
      setDelSuccessVisible(false);
      handleGetAllSchedules();
    }, 2500);
  };

  const handleSetDate = (date) => {
    function formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [month, day, year].join("-");
    }

    let newDate = formatDate(date).toString();
    if (newDate !== "NaN-NaN-NaN") {
      if (newDate && datepickerIsvisible) {
        toggleDatePicker();
        // handleFormChangeGeneral("gameDate", new Date(date).getTime());
        setSelectedDate(newDate);
      }
    }
  };
  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const formattedTime = useMemo(() => {
    if (!isEmpty(savedManualTime)) {
      return formatMinutesToTimeString(savedManualTime);
    } else {
      return null;
    }
  }, [savedManualTime]);

  useEffect(() => {
    if (selectedOppTeam?._id) {
      setInitialStateForm((prevState) => ({
        ...prevState,
        teamB: {
          ...prevState.teamB,
          teamId: selectedOppTeam._id,
          teamName: selectedOppTeam.teamName,
        },
      }));
    }
  }, [selectedOppTeam?._id, selectedOppTeam?.teamName]);

  useEffect(() => {
    if (initialStateForm.homeTeam === operatorTeam?.teamId.teamName) {
      handleFormChange("awayTeam", selectedOppTeam?.teamName);
    } else if (initialStateForm.homeTeam === selectedOppTeam?.teamName) {
      handleFormChange("awayTeam", operatorTeam?.teamId.teamName);
    }
  }, [selectedOppTeam, initialStateForm.homeTeam, operatorTeam?.teamId.teamName]);

  useEffect(() => {
    if (!isEmpty(selectedDate)) {
      handleFormChange("date", selectedDate);
    }
  }, [selectedDate]);

  useEffect(() => {
    if (!isEmpty(formattedTime)) {
      handleFormChange("time", formattedTime);
    }
  }, [formattedTime]);

  //OPPONENT TEAMS
  useEffect(() => {
    (async () => {
      try {
        const response = await getLicenseOppTeams(
          operatorTeam?.teamId?._id,
          user?.token
        );
        setOppTeamData(response.data);
      } catch (error) {
        console.log("errorrrrrrr in all getAllTeams list", error);
        setError(true);
      }
    })();
  }, [operatorTeam?.teamId?._id, user?.token]);

  useEffect(() => {
    (async () => {
      try {
        console.log("gameId:", gameId);
        console.log("token:", user?.token);
  
        setGetScheduleLoading(true);
        let response = await getOneScheduledGame(gameId, user?.token);
  
        console.log("Response from API:", response);
  
        handleFormChange("userId", response.data.userId);
        handleFormChange("teamA", response.data.teamA);
        handleFormChange("teamB", response.data.teamB);
        handleFormChange("date", response.data.date);
        handleFormChange("time", response.data.time);
        handleFormChange("homeTeam", response.data.homeTeam);
        handleFormChange("awayTeam", response.data.awayTeam);
        handleFormChange("conference", response.data.conference);
        handleFormChange("gameStatus", response.data.gameStatus);
        handleFormChange("gameResult", response.data.gameResult);
  
        if (response.data.gameStatus === GameStatusForSchedule.forfeit) {
          if (response.data.gameResult === GameResultEnum.Won) {
            setForfeitBy(response.data.teamB.teamName);
          } else if (response.data.gameResult === GameResultEnum.Lost) {
            setForfeitBy(response.data.teamA.teamName);
          }
        }
  
      } catch (e) {
        console.log("Err at Get One Schedule game!!!", e);
      } finally {
        setGetScheduleLoading(false);
      }
    })();
  }, [gameId, user?.token]);

  const handleSetForfeitBy = (teamName) => {
    if (
      isEmpty(forfeitBy) &&
      isEmpty(initialStateForm.teamA.teamName) &&
      isEmpty(initialStateForm.teamB.teamName)
    ) {
      setError({
        message: "Forfeit by, licensed team and opponent team cannot be empty!",
      });
      return;
    }
    setForfeitBy(teamName);
  };

  const handleSetGameResultOnForfeit = useCallback(() => {
    if (
      !isEmpty(forfeitBy) &&
      !isEmpty(initialStateForm.teamA.teamName) &&
      !isEmpty(initialStateForm.teamB.teamName)
    ) {
      if (forfeitBy === initialStateForm.teamA.teamName) {
        handleFormChange("gameResult", GameResultEnum.Lost);
      } else if (forfeitBy === initialStateForm.teamB.teamName) {
        handleFormChange("gameResult", GameResultEnum.Won);
      }
    }
  }, [forfeitBy, initialStateForm.teamA.teamName, initialStateForm.teamB.teamName]);
  
  useEffect(() => {
    handleSetGameResultOnForfeit();
  }, [
    forfeitBy,
    initialStateForm.teamA.teamName,
    initialStateForm.teamB.teamName,
    handleSetGameResultOnForfeit
  ]);

  const handleSelectGameStatus = (selectedStatus) => {
    handleFormChange("gameStatus", selectedStatus);
    setGameStatusSelected(true);
    setGameStatusVisible(false);
  };

  useEffect(() => {
    if (
      gameStatusSelected &&
      initialStateForm.gameStatus === GameStatusForSchedule.forfeit
    ) {
      setForfeitByVisible(true);
      setGameStatusSelected(false); // Reset the flag after opening the modal
    }
  }, [initialStateForm.gameStatus, gameStatusSelected]);

  const getForfeitp = () => {
    if (initialStateForm.gameStatus === "forfeit") {
      if (initialStateForm.gameResult === GameResultEnum.Won) {
        return { p: "Forfeit 1-0", color: "green" };
      } else if (initialStateForm.gameResult === GameResultEnum.Lost) {
        return { p: "Forfeit 0-1", color: "red" };
      }
    } else if (initialStateForm.gameStatus === "scheduled") {
      return { p: "Scheduled", color: "darkblue" };
    }
    return { p: "select", color: "grey" };
  };

  const handleUpdate = async () => {
    try {
      setUpdateTeamLoader(true);
      await editScheduledGame(gameId, initialStateForm, user?.token);
      console.log("SCHEDULE EDITED successfully !!!");
      toggleSuccessModal();
    } catch (e) {
      setError(e);
    } finally {
      setUpdateTeamLoader(false);
    }
  };
  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      await deleteSchedule(gameId, user?.token);
      toggleDelSuccessModal();
    } catch (e) {
      setError(e);
    } finally {
      setDeleteLoading(false);
    }
    
  };
  
  const goBack = () => {
    history.goBack();
  };
  return (

    <div className="editContainer">
      <div className="backBtn">
      
        <button
          className="actionButtonBack"
          onClick={goBack}
        >
          &larr;
        </button>
      </div>
      <ErrorOverlay
        onBackdropPress={() => setError(null)}
        visible={error ? true : false}
        error={error}
      />

      <div showsVerticalScrollIndicator={false} style={{width: '70%'}}>
        <p className="headerTxt">EDIT SCHEDULED GAME</p>

        <div className="nameInputRow">
          <p className="nameTxt">GAME STATUS:</p>
          <button
            className="selectBttn"
            onClick={() => setGameStatusVisible(true)}
          >
            <div className="inputTeamNameContainer">
              <p
                className="inputTeamName"
                style={{ color: getForfeitp().color }}
              >
                {getForfeitp().p}
              </p>
            </div>
          </button>
        </div>

        {initialStateForm.gameStatus === "forfeit" && (
          <div className="nameInputRow">
            <p className="nameTxt">FORFEITED BY:</p>
            <button
              className="selectBttn"
              onClick={() => setForfeitByVisible(true)}
            >
              <input
                className="inputTeamName"
                // placeholderpColor={styles.grey}
                placeholder="select"
                editable={false}
                value={forfeitBy}
                numberOfLines={1}
              />
            </button>
          </div>
        )}

        <div className="nameInputRow">
          <p className="nameTxt">OPPONENT:</p>
          <button
            className="selectBttn"
            onClick={() => setOppTeamVisible(!opptTeamVisible)}
          >
            <input
              className="inputTeamName"
              // placeholderpColor={styles.grey}
              placeholder="select"
              editable={false}
              // value={selectedOppTeam?.teamName}
              value={initialStateForm?.teamB?.teamName}
              numberOfLines={1}
              // onChangep={(p) => handleFormChange("teamName", p)}
            />
          </button>
        </div>

        <div className="nameInputRow">
          <p className="nameTxt">HOME TEAM:</p>
          <button
            className="selectBttn"
            disabled={selectedOppTeam !== null ? false : true}
            onClick={() => setHomeTeamVisible(!homeTeamVisible)}
          >
            <input
              className="inputTeamName"
              // placeholderpColor={styles.grey}
              placeholder="select"
              editable={false}
              value={initialStateForm.homeTeam}
              numberOfLines={1}
            />
          </button>
        </div>

        <div className="nameInputRow">
          <p className="nameTxt">AWAY TEAM:</p>
          <input
            className="inputTeamName"
            // placeholderpColor={styles.grey}
            placeholder="auto select"
            editable={false}
            value={initialStateForm.awayTeam}
            numberOfLines={1}
          />
        </div>

        <div className="nameInputRow">
          <p className="nameTxt">DATE:</p>
          <button className="selectBttn" onClick={toggleDatePicker}>
            <input
              className="inputTeamName"
              // placeholderpColor={styles.grey}
              placeholder="select"
              editable={false}
              // value={selectedDate}
              value={initialStateForm.date}
              onChangep={(p) => handleFormChange("date", p)}
            />
          </button>
        </div>

        <div className="nameInputRow">
          <p className="nameTxt">TIME:</p>
          <button
            className="selectBttn"
            onClick={() => setManualTimeModalVisible(true)}
          >
            <input
              className="inputTeamName"
              // placeholderpColor={styles.grey}
              placeholder="select"
              editable={false}
              // value={formattedTime}
              value={initialStateForm.time}
              onChangep={(p) => handleFormChange("time", p)}
            />
          </button>
        </div>

        <div className="CheckBoxRow">
          <Checkbox
            style={{ marginRight: 5 }}
            checkBoxColor="darkblue"
            isChecked={initialStateForm.conference}
            onClick={() => {
              handleFormChange("conference", !initialStateForm.conference);
            }}
          />
          <p className="conferenceTxt">Conference</p>
        </div>

        <div className="rowdiv">
          {/* <div /> */}
          <button onClick={handleUpdate} className="saveBtn">
            <p className="btnTxt">SAVE</p>
          </button>

          <button
            onClick={() => setDelIsVisible(!delIsVisible)}
            className="deleteBtn"
          >
            <p className="btnTxt">DELETE</p>
          </button>
        </div>
        {successVisible && (
          <SuccessOverlay
            onBackdropPress={() => toggleSuccessModal(false)}
            isVisible={successVisible}
            type="Game has been updated successfully!"
            noTick={true}
          />
        )}
        {delSuccessVisible && (
          <SuccessOverlay
            onBackdropPress={() => toggleDelSuccessModal(false)}
            isVisible={delSuccessVisible}
            type="Schedule has been deleted successfully!"
            noTick={true}
          />
        )}
        {delIsVisible && (
          <DeleteOverlay
            isVisible={delIsVisible}
            onBackdropPress={() => setDelIsVisible(false)}
            navigation={props.navigation}
            handleDelete={handleDelete}
            // loading={loading}
          />
        )}

        <OppTeamsList
          data={oppTeamData}
          setSelectedOppTeam={setSelectedOppTeam}
          onBackdropPress={() => setOppTeamVisible(false)}
          visible={opptTeamVisible}
          error={error}
        />
        <DatePick
          open={datepickerIsvisible}
          handleSetDate={handleSetDate}
          handelOnCancel={() => setDatepickerIsvisible(false)}
        />
         {homeTeamVisible && (
          <HomeTeamModal
            onBackdropPress={() => setHomeTeamVisible(false)}
            visible={homeTeamVisible}
            licenseTeam={operatorTeam?.teamId}
            oppTeam={selectedOppTeam}
            setSelectedHomeTeam={(val) => handleFormChange("homeTeam", val.teamName)}
            setSelectedVisitorTeam={(val) => {
              handleFormChange("awayTeam", val.teamName);
            }}
          />
        )}

        
        {manualTimeModalVisible && (
          <TimeInputModal
            isVisible={manualTimeModalVisible}
            onBackdropPress={() => setManualTimeModalVisible(false)}
            onSave={setSavedManualTime}
            settings={true}
            heading="Enter Game Time"
            onClose={() => {
              // handleSave();
              setManualTimeModalVisible(false);
            }}
            hours={true}
          />
        )}
        {gameStatusVisible && (
          <GameStatusModal
            isVisible={gameStatusVisible}
            selectGameStatus={handleSelectGameStatus}
            onBackdropPress={() => setGameStatusVisible(false)}
          />
        )}
        {forfeitByVisible && (
          <ForfeitByModal
            isVisible={forfeitByVisible}
            teamNames={[
              initialStateForm.teamA.teamName,
              initialStateForm.teamB.teamName,
            ]}
            selectForfeitBy={(teamName) => {
              handleSetForfeitBy(teamName);
              setForfeitByVisible(false);
            }}
            onBackdropPress={() => setGameStatusVisible(false)}
          />
        )}
      </div>
    </div>
  );
};

export default EditScheduledGame;
